import api, { unwrap } from './client';

// Indirect costs — central tenant × year table, shared across Cash 12M
// (and future modules consuming the same fixed cost base).

export const listIndirectCosts = (tid, year) => {
  const q = year != null ? `?year=${year}` : '';
  return unwrap(api.get(`/indirect-costs/${tid}${q}`));
};

export const listIndirectCostYears = (tid) =>
  unwrap(api.get(`/indirect-costs/${tid}/years`));

export const createIndirectCost = (tid, payload) =>
  unwrap(api.post(`/indirect-costs/${tid}`, payload));

export const updateIndirectCost = (tid, cid, payload) =>
  unwrap(api.patch(`/indirect-costs/${tid}/${cid}`, payload));

export const deleteIndirectCost = (tid, cid) =>
  unwrap(api.delete(`/indirect-costs/${tid}/${cid}`));

export const clearIndirectCosts = (tid, year) =>
  unwrap(api.post(`/indirect-costs/${tid}/clear?year=${year}`));

export const loadDefaultIndirectCosts = (tid, year) =>
  unwrap(api.post(`/indirect-costs/${tid}/load-defaults?year=${year}`));

export const copyIndirectCostsYear = (tid, sourceYear, targetYear, overwrite = false) =>
  unwrap(api.post(`/indirect-costs/${tid}/copy-year?source_year=${sourceYear}&target_year=${targetYear}&overwrite=${overwrite}`));
